export const CATEGORY_WITHOUT_PARTNERS_TEXT = "None here unfortunately. Maybe select another?"
export const SPEND_PARTNER_HEADER = "Spend Partners"
export const SPEND_PARTNER_SUBHEADER = "Places you can spend your points"